import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {defineMessage} from 'react-intl'
import {useD2BCustomer} from '../../hooks/use-d2b-customer'
import useOcapiSite from '../../hooks/useOcapiSite'
import TextAndLink from './text-and-links'

const BusinessProgrammLinks = ({variant}) => {
    const {designerProgramEnabled} = useOcapiSite().preferences
    const isD2BEnabled = useD2BCustomer().enabled

    return (
        <>
            {!variant && designerProgramEnabled && (
                // todo: update link https://stokkeit.atlassian.net/browse/STOK-12816
                <TextAndLink
                    textColor="stokkeGray.accessibleText"
                    href="/home"
                    hybridHref="/home"
                    message={defineMessage({
                        id: 'register_form.message.designer_program',
                        defaultMessage:
                            'If you are a designer or interior architect, <textlink>create an account here and discover your exclusive advantage.</textlink>'
                    })}
                />
            )}
            {isD2BEnabled && (
                // todo: update link https://stokkeit.atlassian.net/browse/STOK-12816
                <TextAndLink
                    textColor="stokkeCore.black"
                    href="/home"
                    hybridHref="/home"
                    message={defineMessage({
                        id: 'register_form.create_business_account',
                        defaultMessage:
                            '<textlink>StokkePro for Businesses, create an account here and discover your exclusive advantage.</textlink>'
                    })}
                />
            )}
        </>
    )
}

BusinessProgrammLinks.propTypes = {
    variant: PropTypes.string
}

export default BusinessProgrammLinks
